<template>
  <div class="hamburger-menu">
    <div class="grid-block">
      <ul class="grid-steps">
        <li v-for="(box, index) in boxes" :key="index" class="grid-steps__step" :class="[`step-${index}`, { 'has-component': box.component }]" :disabled="box.disabled">
          <template v-if="!box.component">
            <button class="btn btn-none" @click.prevent="manageBoxIteraction(box)">
              <div class="wrapp-step">
                <div class="wrapp-icon" v-show="box.iconHtml" v-html="box.iconHtml"></div>
                <div class="wrapp-title" v-t="box.title" />
              </div>
            </button>
          </template>
          <template v-else>
            <component :is="box.component" />
          </template>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import FormSearch from 'theme/components/Search/FormSearch'
import each from 'lodash/each'
import filter from 'lodash/filter'
import { EventBus } from '@/helpers'
import { mapGetters } from 'vuex'

export default {
  name: 'HamburgerMenu',
  data () {
    return {
      boxes: [
        {
          component: 'FormSearch',
          to: { name: 'home' },
          title: '',
          disabled: false,
          iconHtml: '<svg class="o-icon fill-black"><use xlink:href="#click-collect"></use></svg>'
        },
        {
          component: false,
          to: { name: 'myOrders' },
          title: 'online-orders',
          disabled: false,
          iconHtml: '<svg class="o-icon fill-black"><use xlink:href="#click-collect"></use></svg>'
        },
        //  {
        //   component: false,
        //   // callback: this.goToReturn,
        //   title: 'route.return-refunds',
        //   disabled: true,
        //   iconHtml: '<svg class="o-icon fill-black"><use xlink:href="#return-order"></use></svg>'
        // },
        /* {
          component: false,
          callback: this.goToRegister,
          title: 'new-customer',
          disabled: false,
          iconHtml: '<svg class="o-icon fill-black"><use xlink:href="#user-customer-1"></use></svg>'
        }, */
        {
          component: false,
          to: { name: 'home' },
          title: 'catalog',
          disabled: false,
          iconHtml: '<svg class="o-icon fill-black"><use xlink:href="#shop"></use></svg>'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      items: 'ui/menu',
      activeCategoryList: 'category/activeCategoryList'
    }),
    shopListItems () {
      return filter(this.items, { type: 'shop' })
    }
  },
  methods: {
    prepareForSearch ($event) {
      // prepare layout for search
      let $panel = $('.grid-steps__step:not(.has-component)')
      if ($event) {
        $panel.fadeOut()
      } else {
        $panel.fadeIn()
      }
    },
    getCategoryVisible (categories) {
      if (categories && categories.length) {
        return filter(categories, { include_in_menu: true, is_active: true })
      }
    },
    shopSubListItems () {
      var allSubChild = []
      let newItem
      const _this = this
      each(this.shopListItems, (r) => {
        r.root.forEach(item => {
          newItem = { ...item }
          newItem.flattedChild = []
          if (newItem.childrenData.length) {
            newItem.flattedChild = _this.getSubListItems(newItem.childrenData)
          }
          allSubChild.push(newItem)
        })
      })
      // child
      return allSubChild
    },
    manageBoxIteraction (box) {
      if (box.to) {
        this.$store.commit('ui/setLeftActiveComponent', {})
        return this.$router.push(box.to)
      } else if (box.callback) {
        return box.callback.call()
      } else {
        console.log('nothing to do')
      }
    },
    goToReturn () {
      let componentToLoad = import('theme/pages/CreateGuestReturn')
      this.$store.dispatch('ui/loadLeftActiveComponent', { component: componentToLoad })
    },
    goToRegister () {
      let componentToLoad = import('theme/pages/Register')
      this.$store.dispatch('ui/loadLeftActiveComponent', { component: componentToLoad })
    }
  },
  mounted () {
    EventBus.$on('searchBar:readyForSearch', this.prepareForSearch)
  },
  destroyed () {
    EventBus.$off('searchBar:readyForSearch', this.prepareForSearch)
  },
  components: {
    FormSearch
  }
}
</script>
